import { render, staticRenderFns } from "./CameraModalBody.vue?vue&type=template&id=f8c25eb0&scoped=true&"
import script from "./CameraModalBody.vue?vue&type=script&lang=js&"
export * from "./CameraModalBody.vue?vue&type=script&lang=js&"
import style0 from "./CameraModalBody.vue?vue&type=style&index=0&id=f8c25eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c25eb0",
  null
  
)

export default component.exports